import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export type IRechargeEligibilityInfo = {
  has_recharge_records: boolean
  is_personal_account: boolean
  is_latest_recharge_over_30_days: boolean
  has_pay_packages?: boolean
}

export type IActivityRechargeParams = {
  activityCode: string
  platform?: string
  source?: string
}

export type ICreditsControlResponse = {
  credits_package: boolean
}

export type IPersonalRechargeItem = {
  tenant_user_id: string
  credits: number
  source: string
  source_id: string
  charge_mode: string
  begin_at: number
  end_at: number
  remark: string
  recharge_at: number
  used_credits?: number
}

export type IPersonalCreditsDetailResponse = {
  total_credits: number
  used_credits: number
  daily_used_credits: number
  frozen_credits: number
  items: IPersonalRechargeItem[]
}

export type ICompanyRechargeItem = {
  company_id: string
  credits: number
  source: string
  charge_mode: string
  begin_at: number
  end_at: number
  contract_no: string
  remark: string
  recharge_at: number
  created_by: string
  created_at: number
}

export type ICompanyCreditsDetailResponse = {
  total_credits: number
  used_credits: number
  daily_used_credits: number
  frozen_credits: number
  user_daily_limit: number
  company_user_daily_limit: number
  company_total_daily_limit: number
  items: ICompanyRechargeItem[]
}

export class CreditsApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getRechargeInfo(): Promise<IHttpWrap<IRechargeEligibilityInfo>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/personal/recharge-info'),
    })
  }

  async getCreditsControl(): Promise<IHttpWrap<ICreditsControlResponse>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/control'),
    })
  }

  async rechargeActivityCredits(
    params: IActivityRechargeParams
  ): Promise<IHttpWrap<{ recharge_record_id?: string }, { errorCode: number; errorMsg?: string; status: boolean }>> {
    return this.http({
      method: 'POST',
      url: this.getUrl('ai-service/credits/activity/recharge'),
      data: {
        activity_code: params.activityCode,
        platform: params.platform,
        source: params.source,
      },
    })
  }

  async getPersonalCreditsDetail(): Promise<IHttpWrap<IPersonalCreditsDetailResponse>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/personal/detail'),
    })
  }

  async getCompanyCreditsDetail(): Promise<IHttpWrap<ICompanyCreditsDetailResponse>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/company/detail'),
    })
  }
}
